import { Button, CircularProgress, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { paymentServices } from 'src/services/payment/Payment.service'

export const UserInfoModal = ({paymentId, setSelectedPaymentId}) => {
    const translate = useTranslate()
    const [userInfoLoading, setUserInfoLoading] = useState(false)
    const [userInfo, setUserInfo] = useState(null)
    
    const getUserInfo = async () =>{
        setUserInfoLoading(true)
        await paymentServices.getUserInformation(paymentId).then((res)=>{
            setUserInfo(res.user)
        }).finally(()=>{
            setUserInfoLoading(false)
        })
    }

    useEffect(()=>{
        getUserInfo()
    },[])
  return (
    <div style={{display:'flex', flexDirection:'column'}}>
        {userInfoLoading ?
            <CircularProgress size={'35px'}/>
             :
            <Grid container spacing={3}>
                <ShowListElement sm={6} label={translate('ra.field.name')} value={userInfo?.firstname} />
                <ShowListElement sm={6} label={translate('ra.field.surname')} value={userInfo?.surname} />
                <ShowListElement sm={6} label={translate('ra.field.username')} value={userInfo?.username} />
                <ShowListElement sm={6} label={translate('ra.field.mail')} value={userInfo?.mail} />
                {/* <ShowListElement sm={6} label={translate('ra.field.created_at')} value={parseDateFormat(userInfo?.created_at)} /> */}
            </Grid>
        }
        <Button
            style={{alignSelf:'self-start'}}
            variant='contained'
            onClick={()=>setSelectedPaymentId(null)}
        >
            {translate('ra.action.close')}
        </Button>
    </div>
  )
}
